module.exports = __webpack_public_path__ + "media/flags/cd-b5930509.svg";